<div class="col-md-12 mb-30" *ngIf="Selected_LetterrequestcustomerRelative_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0"> اطلاعات فاکتورها (نامه های تایید شروع کار) </h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="Filter_title" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_LetterrequestcustomerRelative()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی شماره نامه </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره نامه</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterrequestcustomerRelative
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_LetterrequestcustomerRelative.length
                      }
            ">
              <td>{{DataList_LetterrequestcustomerRelative.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customer}}</td>
              <td>
                <button type="button" (click)="Set_Form_LetterrequestcustomerRelative_View(item,'Form')"  class="btn btn-danger"> مشاهده
                  <i class="fa fa-eye"></i> </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_LetterrequestcustomerRelative_Record_Switcher=='Form'">
  <app-LetterrequestcustomerFactorForm [inner_Letter]="Data_Seleted_Record"
  (OnBack_LetterrequestcustomerFactor_Action)="Set_List_LetterrequestcustomerRelative_View()">
  </app-LetterrequestcustomerFactorForm>
</div>

